import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: people.PolicyAcceptance.
export default class PolicyAcceptance extends Fragment {
  declare [Type]: 'people/policy-acceptance';

  // policyId references the id of the policy that was accepted. See
  // utils/policies.
  @attr('string', { defaultValue: '' })
  declare policyId: string;

  // acceptedDate is the date the person accepted this policy, formatted as
  // YYYY-MM-DD.
  @attr('string', { defaultValue: '' })
  declare acceptedDate: string;
}
